import React from 'react';

import styles from './AddToCartPopup.module.scss';
import Button from '@srcDS/components/atoms/button';
import PrimaryLoader from '@srcDS/components/atoms/primaryLoader/PrimaryLoader';
import { CrossLineLong } from '@srcDS/components/atoms/icons';
import clsx from 'clsx';
import { SizeButtonsProps } from '@srcDS/js/components/molecules/quickAdd/useQuickAdd';
import { AddToCartPopupProps } from './types';

const AddToCartPopup: React.FC<AddToCartPopupProps> = ({ onClose, product, sizeButtons }) => {
  if (!product || !sizeButtons) return null;

  return (
    <div id="add-to-cart-popup" className={styles.root}>
      <div className={styles.overlay} onClick={onClose}></div>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.headerTitle}>Choose options</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M18 6.28857L6 18.2886M6 6.28857L18 18.2886"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className={styles.content}>
          <div>
            <h2 className={styles.title}>{product?.title}</h2>
            <p className={styles.subtitle}>{product?.subtitle}</p>
          </div>

          <div className={styles.sizeSelector}>
            <p className={styles.sizeSelectorLabel}>Select size:</p>
            <div className={styles.sizes}>
              {Boolean(sizeButtons?.length) &&
                sizeButtons?.map(({ key, label, isAvailable, isLoading, isActionDisabled, onClick }: SizeButtonsProps) => {
                  return (
                    // @ts-ignore
                    <Button
                      className={clsx(styles.size, {
                        [styles.isOutOfStock]: !isAvailable,
                      })}
                      key={key}
                      variant="primary"
                      as="text"
                      disabled={!isAvailable || isActionDisabled}
                      onClick={onClick}
                    >
                      <div>
                        {isLoading ? <PrimaryLoader mode="segment" size={12} /> : label}
                        {!isAvailable && <div className={styles.crossLine}/>}
                      </div>
                    </Button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToCartPopup;
